// Shared field validation state helper for PaymentCardForm and SecurityCodeComponent
export function getFieldValidationState(element, highlightedField, newInputStates, InputState) {
  return highlightedField && newInputStates[element] === InputState.Standard
    ? InputState.Error
    : newInputStates[element];
}
